/* eslint-disable prettier/prettier */
export default () =>({
  status: "authenticating",
  user: null,
  rol: null,
  idToken: null,
  refreshToken: null
})